import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['notice'];

  // LRPO-5506 — the dwell time used to be a literal 3000 shared by every
  // auto-dismiss notice in the app, so a notice the user is actually looking
  // at could not be given longer without slowing down every other surface.
  // The default keeps shared/_flash + shared/_checkout_notices unchanged; the
  // inline recipient notice opts into a longer dwell per instance.
  static values = { delay: { type: Number, default: 3000 } };

  connect() {
    // LRPO-5437 — this used to remove `document.querySelector('#flash-container')`,
    // a global lookup. Every rendered flash shares the same `#flash-container`
    // id (duplicate ids across instances), so querySelector always matched the
    // FIRST one in the DOM regardless of which instance's timer fired — a
    // later toast's timeout stripped an EARLIER toast's text/close button and
    // left its wrapper behind as an empty box (the reported "notifications
    // remain visible, sometimes without text"). Scoping removal to
    // `this.element` guarantees each instance only ever removes itself.
    if (!this.hasNoticeTarget) return;

    this.timeout = setTimeout(() => {
      // LRPO-5451 — re-check the target at FIRE time, not just at schedule
      // time. Bootstrap's `data-bs-dismiss="alert"` btn-close removes only the
      // inner `.alert` (which carries data-notice-target) and leaves this
      // data-controller="notice" wrapper connected, so disconnect() never runs
      // and this timer is never cleared. Reading `this.noticeTarget` after the
      // target is gone throws `Missing target element "notice"` (the reported
      // console error). If the notice was already dismissed, just drop the now
      // empty wrapper and bail.
      if (!this.hasNoticeTarget) {
        this.element.remove();
        return;
      }

      this.noticeTarget.classList.add('animate__fadeOut');
      this.element.remove();
    }, this.delayValue);
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout);
  }
}
